const state = {
  isLoading: false
}

const getters = {
  isRouterLoading: state => {
    return state.isLoading
  }
}

const mutations = {
  SET_ROUTER_LOADING: (state, isLoading) => {
    state.isLoading = isLoading
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/router.js